<template>
  <HomePC v-if="isPc" :slider="slider" :catagory="catagory" :loading="loading" :lastVideo="lastVideo"></HomePC>
  <HomeMobile v-else :slider="slider" :catagory="catagory" :loading="loading" ref="mobileHome" :lastVideo="lastVideo"></HomeMobile>
</template>

<script>
import { /*get_audition_course,*/ get_class } from "@/api/category";
import request from "@/utils/request";
import HomePC from "./HomePC.vue";
import HomeMobile from "./HomeMobile.vue";

export default {
  name: "home",
  components: {
    HomePC,
    HomeMobile
  },
  data () {
    return {
      slider: [1, 2, 3, 4, 5],
      catagory: [],
      loading: '正在加载课程列表...',
      isPc: false,
      lastVideo: null
    };
  },
  async created () {
    this.isPc = this.IsPCVisted();
    try {
      const {
        data: { data: category }
      } = await get_class(1);
      // API 返回对象格式 { "0": {...}, "12": {...} }，转成数组
      this.catagory = Array.isArray(category) ? category : Object.values(category);
    } catch (err) {
      this.$createToast({
        txt: err,
        type: "error",
        time: 1500
      }).show();
    } finally {
      this.loading = '';
    }
    // 获取上次观看记录
    try {
      const res = await request({
        url: '/api/users/progress',
        method: 'get'
      });
      if (res.data && res.data.video_id) {
        this.lastVideo = res.data;
      }
    } catch {
      // 无记录或接口异常不展示
    }
  },
  methods: {
    IsPCVisted() {
      // 屏幕宽度判断：小于 768px 视为移动端
      if (window.innerWidth < 768) return false;
      // UA 判断
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod", "Mobi", "Mobile"];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) !== -1) {
          return false;
        }
      }
      return true;
    }
  }
};
</script>

<style>
</style>